import { defineComponent as _defineComponent } from 'vue'
import AzImg from '~/components/Atoms/AzImg.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'GalleryStickers',
  props: {
  mainAttributes: {
    type: Object,
    default: () => {},
  },
},
  setup(__props) {

const props = __props;



const attributes = props.mainAttributes.fields?.productAttribute;
const imageFile = attributes?.fields?.image?.fields;
const imageUrl = imageFile?.file?.url;
const imageTitle = imageFile?.title;

return { __sfc: true,props, attributes, imageFile, imageUrl, imageTitle, AzImg }
}

})